/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ yearly_price: NonNullable<unknown> }} Subscription_Price_YearInputs */

const en_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/year`)
};

const ar_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/سنة`)
};

const de_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/Jahr`)
};

const es_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/año`)
};

const fr_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/an`)
};

const it_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/anno`)
};

const ja_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/年`)
};

const ko_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/년`)
};

const pt_br_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/ano`)
};

const ru_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/год`)
};

const th_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/ปี`)
};

const tr_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/yıl`)
};

const zh_cn_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/年`)
};

const zh_tw_subscription_price_year = /** @type {(inputs: Subscription_Price_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price}/年`)
};

/**
* | output |
* | --- |
* | "{yearly_price}/year" |
*
* @param {Subscription_Price_YearInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_price_year = /** @type {((inputs: Subscription_Price_YearInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Price_YearInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_price_year(inputs)
	if (locale === "ar") return ar_subscription_price_year(inputs)
	if (locale === "de") return de_subscription_price_year(inputs)
	if (locale === "es") return es_subscription_price_year(inputs)
	if (locale === "fr") return fr_subscription_price_year(inputs)
	if (locale === "it") return it_subscription_price_year(inputs)
	if (locale === "ja") return ja_subscription_price_year(inputs)
	if (locale === "ko") return ko_subscription_price_year(inputs)
	if (locale === "pt_br") return pt_br_subscription_price_year(inputs)
	if (locale === "ru") return ru_subscription_price_year(inputs)
	if (locale === "th") return th_subscription_price_year(inputs)
	if (locale === "tr") return tr_subscription_price_year(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_price_year(inputs)
	return zh_tw_subscription_price_year(inputs)
});